// @ts-strict-ignore header package fails verification
import { canvas } from '@carvana/helios-styles';
import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { hasMobileUserAgent } from '@carvana/stc-utilities';
import HeaderSkeleton, { getHeaderManifest } from '@carvana/header';
import classnames from 'classnames';
import { useEffect } from 'react';
import styled from 'styled-components';
import '@carvana/header/styles.css';

export const Container = styled.div`
  background-color: #e4ecf0;
  width: 100%;
  &.nativeMobile {
    height: max-content;
  }
`;

export const Inner = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1800px;

  &.helios {
    background-color: ${canvas.default};
  }
`;

const chatContext = {
  contextType: 'carvana_trade'
};

const Header = () => {
  useEffect(() => {
    MfeLoad({
      files: [
        [
          'HeaderModule',
          [
            {
              component: 'default',
              default: {
                file: 'index.js',
                manifest: getHeaderManifest(process.env.CARVANA_APP_ENVIRONMENT)
              }
            }
          ]
        ]
      ]
    });
  }, []);

  const nativeMobile = typeof window === 'object' ? hasMobileUserAgent(window.navigator) : false;

  return (
    <Container className={classnames({ nativeMobile })}>
      <Inner>
        <MfeReactComponent
          component="default"
          module="HeaderModule"
          environment={process.env.CARVANA_APP_ENVIRONMENT}
          loading={<HeaderSkeleton route="/sell-my-car" />}
          useProvider
          shouldShowCovid19Banner={false}
          chatContext={chatContext}
        />
      </Inner>
    </Container>
  );
};

export default Header;
